import {
  BsArrowCounterclockwise,
  BsArrowRepeat,
  BsBoxArrowUpRight,
  BsBank,
  BsBell,
  BsBookmark,
  BsBookmarkFill,
  BsBoxArrowRight,
  BsCalendar,
  BsChatDots,
  BsCheck,
  BsCheckCircle,
  BsChevronDown,
  BsChevronLeft,
  BsChevronRight,
  BsClipboardCheck,
  BsCopy,
  BsCreditCard,
  BsDownload,
  BsDropletFill,
  BsEnvelope,
  BsEnvelopeOpen,
  BsExclamationTriangle,
  BsEye,
  BsEyeSlash,
  BsFileEarmark,
  BsFileEarmarkArrowDown,
  BsFileEarmarkText,
  BsFillEnvelopePaperFill,
  BsFillPersonFill,
  BsGear,
  BsGeo,
  BsHourglass,
  BsImage,
  BsInfoCircle,
  BsLayoutSidebar,
  BsLayoutSidebarReverse,
  BsLayoutSplit,
  BsLayoutThreeColumns,
  BsLink45Deg,
  BsList,
  BsMap,
  BsPencil,
  BsPencilSquare,
  BsPeopleFill,
  BsPersonBadge,
  BsPersonLinesFill,
  BsPlus,
  BsPlusCircleFill,
  BsSearch,
  BsSlashCircle,
  BsSortDown,
  BsSortDownAlt,
  BsSpeedometer,
  BsSpeedometer2,
  BsTextCenter,
  BsThreeDotsVertical,
  BsTrash,
  BsTriangleFill,
  BsTypeBold,
  BsTypeItalic,
  BsTypeUnderline,
  BsWrench,
  BsX,
} from 'react-icons/bs';

import {
  type IconBaseProps,
  type IconContext,
  type IconType as IconBaseType,
} from 'react-icons';
import React from 'react';

const ICON_MAP = {
  'add-new': BsPencilSquare,
  accounts: BsPersonLinesFill,
  bank: BsBank,
  bell: BsBell,
  billing: BsCreditCard,
  bookmark: BsBookmark,
  'bookmark-fill': BsBookmarkFill,
  bold: BsTypeBold,
  calendar: BsCalendar,
  'chat-dots': BsChatDots,
  check: BsCheck,
  'check-circle': BsCheckCircle,
  'chevron-down': BsChevronDown,
  'chevron-left': BsChevronLeft,
  'chevron-right': BsChevronRight,
  'clipboard-check': BsClipboardCheck,
  copy: BsCopy,
  customer: BsPersonBadge,
  dashboard: BsSpeedometer2,
  download: BsDownload,
  draggable: BsThreeDotsVertical,
  droplet: BsDropletFill,
  edit: BsPencil,
  'external-link': BsLink45Deg,
  'eye-open': BsEye,
  'eye-slash': BsEyeSlash,
  eye: BsEye,
  file: BsFileEarmarkText,
  'file-download': BsFileEarmarkArrowDown,
  gauge: BsSpeedometer,
  geo: BsGeo,
  hazard: BsExclamationTriangle,
  'hour-glass': BsHourglass,
  image: BsImage,
  info: BsInfoCircle,
  italic: BsTypeItalic,
  link: BsBoxArrowUpRight,
  list: BsList,
  logo: BsDropletFill,
  logout: BsBoxArrowRight,
  mail: BsEnvelope,
  'mail-open': BsEnvelopeOpen,
  map: BsMap,
  notices: BsFillEnvelopePaperFill,
  people: BsPeopleFill,
  person: BsFillPersonFill,
  'person-lines': BsPersonLinesFill,
  plus: BsPlus,
  'plus-circle': BsPlusCircleFill,
  repeat: BsArrowRepeat,
  'right-pane': BsLayoutSidebarReverse,
  save: BsFileEarmark,
  search: BsSearch,
  settings: BsGear,
  'sidebar-toggle': BsLayoutSidebar,
  'slash-circle': BsSlashCircle,
  'sort-asc': BsSortDownAlt,
  'sort-desc': BsSortDown,
  'split-pane': BsLayoutSplit,
  'text-center': BsTextCenter,
  'three-columns': BsLayoutThreeColumns,
  'triangle-fill': BsTriangleFill,
  trash: BsTrash,
  underline: BsTypeUnderline,
  undo: BsArrowCounterclockwise,
  wrench: BsWrench,
  x: BsX,
} as const satisfies Record<string, IconBaseType>;

export type IconType = keyof typeof ICON_MAP;

export type IconProps = Omit<IconContext, 'size'> &
  IconBaseProps & {
    icon: IconType;
  };

export const icons = Object.keys(ICON_MAP) as ReadonlyArray<IconType>;

const Icon = (props: IconProps): JSX.Element => {
  const { icon, ...rest } = props;
  const Component = ICON_MAP[icon];

  return <Component {...rest} />;
};

export default Icon;
